import { TextSizes } from "@smartsuite/react-ui/lib/components/typography/Text/Text.constants";
import { useMeasure } from "@uidotdev/usehooks";
import {
  SwitchButton,
  SwitchButtonProps,
} from "@smartsuite/react-ui/lib/components/buttons/SwitchButton/SwitchButton";
import { stylesSwitchButtonText } from "@smartsuite/react-ui/lib/components/buttons/SwitchButton/SwitchButton.constant";

export const StyledSwitchButton: React.FC<SwitchButtonProps> = ({
  styles = {},
  options,
  ...props
}) => {
  const [containerRef, { width }] = useMeasure();
  let widthItem: number | undefined;

  // Calculate width of each item based on container (sidebar minus padding) width and number of options.
  // Decrease the padding between items.
  if (width && options.length) {
    widthItem = width / options.length - 2;
  }

  return (
    <div ref={containerRef} className="full">
      <SwitchButton
        styles={{
          ...stylesSwitchButtonText,
          widthSlider: "auto",
          widthItem,
          background: "#F3F3F4",
          backgroundHover: "#F3F3F4",
          backgroundSlider: "#FFFFFF",
          color: "#878B92",
          colorHover: "#878B92",
          colorActive: "#2E3538",
          colorActiveHover: "#2E3538",
          textSize: TextSizes.XS,
          marginSliderLeft: 0,
          paddingSlider: "2px",
          ...styles,
        }}
        options={options}
        {...props}
      />
    </div>
  );
};
